import React, { useEffect, useState } from "react";
import DashboardStyle from "../../../../dashboard/Styles/Dashboard.module.css";
import PageLayout from "../../../Components/Layout/PageLayout";
// import { FormTemplate } from "../../../Components/Forms/InputTemplate";
// import { FormProvider, useForm } from "react-hook-form";
// import { FiExternalLink } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router";
import { FormatDateTime } from "../../../../../utils/functions/ResourceFunctions";
import {
  ApproveProcQuotation,
  DeclineProQuotation,
  GetPaymentTerms,
  GetSingleProcQuotations,
} from "../../../../../utils/redux/Procurement/ProcurementSlice";
import {
  PageActions,
  // TableActions,
  TableActionsDownload,
} from "../../../Components/Misc/Actions";
import Table from "../../../Components/Table/Table";
import { FormatCurrency } from "../../../../../utils/functions/FormatCurrency";
import { useApprovals } from "../../Vendors/VendorApprovals/useApprovals";
import {
  STATUS,
  // findState,
} from "../../Vendors/Management/ViewVendorsOperations";
import ViewProcessingStages from "../../../Components/Modals/Processingstages/ViewProcessingStages";
import { toast } from "react-toastify";
import { USER_CATEGORY } from "../../../../../utils/Enums";
import { GetLocalStorage } from "../../../../../utils/functions/GetLocalStorage";
// import { GetSingleVendor } from "../../../../../utils/redux/Vendor/VendorSlice";
import AddPaymentTerms from "./AddPaymentTerms";
// import { SendPaymentToFinance } from "../../../../../utils/redux/Finance/PayrollSlice";
import { CreateAssetRegister } from "../../../../../utils/redux/AssetsSetUp/AssetSetUpSlice";
import { useGetBudgetDetailsByIdQuery } from "../../../../api";
import { GetDocumentDifinitionById } from "../../../../../utils/redux/HR/HRSlice";
import PreviewBtn from "../../../Components/Modals/PreviewBtn";
import { formatNumberWithCommas } from "../../../../../utils/Misc";
// import { isExists } from "date-fns";

function ViewEmployeeQuotation() {
  const dispatch = useDispatch();
  const { id } = useParams();

  const data = useSelector((state) => state?.procurement);
  const requisition = data?.proc_quotation_data?.responseObject;

  const [documents, setDocuments] = useState([]);
  const [refersh, setRefresh] = React.useState(false);
  const [paymentTerms, setPaymentTerms] = useState([]);

  const fileType = (file) => {
    switch (parseInt(file)) {
      case 1:
        return ".pdf";
      case 2:
        return ".docx,.doc";
      case 3:
        return ".pptx,.ppt";
      case 4:
        return ".xlsv,.xls,.csv";
      case 5:
        return ".jpeg,.jpg,.gif";
      default:
        return "*/*";
    }
  };

  useEffect(() => {
    const fetchDocuments = async () => {
      if (
        requisition?.quotationRecuisitionDocuments ||
        requisition?.procurementDocuments
      ) {
        const combined = []
          .concat(requisition.quotationRecuisitionDocuments || [])
          .concat(requisition.procurementDocuments || []);

        const documents = await Promise.all(
          combined.map(async (document) => {
            const response = await dispatch(
              GetDocumentDifinitionById(document.definitionId)
            );
            return {
              ...document,
              fileType: fileType(response.payload.responseObject.fileType),
            };
          })
        );
        setDocuments(documents);
      }
    };

    fetchDocuments();
  }, [requisition, dispatch, setDocuments]);

  const paymentTerm = useSelector(
    (state) => state?.procurement?.paymentTerms?.result
  );

  useEffect(() => {
    paymentTerm?.length > 0 &&
      setPaymentTerms(
        paymentTerm?.map((dat) => ({
          ...dat,
          procurementInitiatorId:
            data?.proc_quotation_data?.responseObject?.procurementInitiatorId,
          procurementInitiatorName:
            data?.proc_quotation_data?.responseObject?.procurementInitiatorName,
        }))
      );
  }, [
    data?.proc_quotation_data?.responseObject?.procurementInitiatorId,
    data?.proc_quotation_data?.responseObject?.procurementInitiatorName,
    paymentTerm,
  ]);
  const payload = {
    id: data?.proc_quotation_data?.responseObject?.budgetId,
  };
  const { data: budgetSummaryDataById } = useGetBudgetDetailsByIdQuery(payload);

  const { openModal, closeModal } = useApprovals({});
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(GetSingleProcQuotations(id));
    dispatch(GetPaymentTerms(id));
  }, [dispatch, id]);

  useEffect(() => {
    if (requisition?.recommendationStatus === true) {
      dispatch(
        CreateAssetRegister({
          assetCategory: 1,
          assetSetups: [
            {
              assetName: requisition?.recommendedAsset,
              assetBrand: requisition?.brand,
              classId: requisition?.assetClassId,
              classSubClassId: requisition?.assetSubClassId,
              assetDescription: requisition?.recommendedAssetDescription,
            },
          ],
        })
      );
    }
  }, [
    dispatch,
    requisition?.assetClassId,
    requisition?.assetSubClassId,
    requisition?.brand,
    requisition?.recommendationStatus,
    requisition?.recommendedAsset,
    requisition?.recommendedAssetDescription,
  ]);

  return (
    <PageLayout title={"Quotation Details"} hasBack={true}>
      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          Process <br /> Information
        </h4>
        <div className={DashboardStyle.labels_group}>
          <div>
            <div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "0.8rem",
                  gap: "0.6rem",
                  alignItems: "center",
                }}
              >
                <p style={{ marginBottom: "0px" }}>Initiated By:</p>
                <h4>{requisition?.initiatorName}</h4>
              </div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "0.8rem",
                  gap: "0.6rem",
                  alignItems: "center",
                }}
              >
                <p style={{ marginBottom: "0px" }}>Date:</p>
                <h4>{FormatDateTime(requisition?.dateInitiated, "ll")}</h4>
              </div>
            </div>
            <div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "0.8rem",
                  gap: "0.6rem",
                  alignItems: "center",
                }}
              >
                <p style={{ marginBottom: "0px" }}>Last Reviewed By:</p>
                <h4>{requisition?.lastReveiwed?.lastReviewedBy}</h4>
              </div>
              <div
                style={{
                  display: "flex",
                  marginBottom: "0.8rem",
                  gap: "0.6rem",
                  alignItems: "center",
                }}
              >
                <p style={{ marginBottom: "0px" }}>Date:</p>
                <h4>
                  {FormatDateTime(
                    requisition?.lastReveiwed?.lastReveiwedByDate,
                    "ll"
                  )}
                </h4>
              </div>
            </div>
          </div>
          <div>
            <div>
              <p>Request Id:</p>
              <h4>{requisition?.identifier}</h4>
            </div>
            <div>
              <p>Process Status</p>
              <h4
                style={{
                  color:
                    requisition?.registrationState === "Initiated"
                      ? "#815103"
                      : requisition?.registrationState === "Approved"
                      ? "#0F6308"
                      : requisition?.registrationState === "Declined"
                      ? "#8A002B"
                      : "",
                }}
              >
                {requisition?.registrationState}
              </h4>
            </div>
            <div>
              <ViewProcessingStages
                schema="RF"
                entityName="QuotationDecision"
                entityIdFieldName="QuotationId"
                id={id}
              />
            </div>
          </div>
        </div>
      </section>
      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          Requisition <br /> Information
        </h4>
        <div className={DashboardStyle.labels_group}>
          <div>
            <div>
              <p>Requisition Type</p>
              <h4>{requisition?.requisitionType}</h4>
            </div>
            <div>
              <p>Vendor</p>
              <h4>{requisition?.vendorName}</h4>
            </div>
          </div>
          <div>
            <div>
              <p>Description</p>
              <h4>{requisition?.description}</h4>
            </div>
            <div>
              <p>Quantity</p>
              <h4>{requisition?.quantity}</h4>
            </div>
            <div>
              <p>Requisition Expiry Date</p>
              <h4>
                {FormatDateTime(requisition?.requisitionExpiryDate, "ll")}
              </h4>
            </div>
          </div>
        </div>
      </section>
      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          Quotation <br /> Information
        </h4>
        <div className={DashboardStyle.labels_group}>
          <div>
            <div>
              <p>Item Name</p>
              <h4>{requisition?.brand}</h4>
            </div>
            <div>
              <p>Unit Price</p>
              <h4>
                {requisition?.unitPrice
                  ? `${requisition.currency} ${formatNumberWithCommas(
                      requisition?.unitPrice
                    )}`
                  : "N/A"}
              </h4>
            </div>
          </div>
          <div>
            <div>
              <p>Quantity</p>
              <h4>{requisition?.quantity}</h4>
            </div>
            <div>
              <p>Delivery Cost</p>
              <h4>
                {requisition?.deliveryCost
                  ? `${requisition.currency} ${formatNumberWithCommas(
                      requisition?.deliveryCost
                    )}`
                  : "N/A"}
              </h4>
            </div>
            <div>
              <p>Warranty</p>
              <h4>{requisition?.waranty}</h4>
            </div>
          </div>
          <div>
            <div>
              <p>Total Price</p>
              <h4>
                {requisition?.totalPrice
                  ? `${requisition.currency} ${formatNumberWithCommas(
                      requisition?.totalPrice
                    )}`
                  : "N/A"}
              </h4>
            </div>
            <div>
              <p>Support Included</p>
              <h4>{requisition?.supportIncluded}</h4>
            </div>
            <div>
              <p>Delivery Schedule</p>
              <h4>{FormatDateTime(requisition?.deliverySchedule)}</h4>
            </div>
          </div>
        </div>
      </section>
      <section
        style={{
          borderTop: "unset",
        }}
        className={DashboardStyle.form_section}
      >
        <h4 className={DashboardStyle.form_section_title}>
          Budget <br /> Information
        </h4>
        <div className={DashboardStyle.labels_group}>
          <div>
            <div>
              <p>Item Name</p>
              <h4>
                {budgetSummaryDataById?.responseObject?.item || "N/A"}
              </h4>{" "}
              {/* Updated with item name */}
            </div>
            <div>
              <p>Budget Type</p>
              <h4>
                {budgetSummaryDataById?.responseObject?.budgetType || "N/A"}
              </h4>{" "}
              {/* Updated with budget type */}
            </div>
            <div>
              <p>Description</p>
              <h4>
                {budgetSummaryDataById?.responseObject?.description || "N/A"}
              </h4>{" "}
              {/* Updated with description */}
            </div>
          </div>
          <div>
            <div>
              <p>Unit Price</p>
              <h4>
                {FormatCurrency(
                  budgetSummaryDataById?.responseObject?.unitPrice
                ) || "N/A"}
              </h4>{" "}
              {/* Updated with unit price */}
            </div>
            <div>
              <p>Quantity</p>
              <h4>
                {budgetSummaryDataById?.responseObject?.quantity || "N/A"}
              </h4>{" "}
              {/* Updated with quantity */}
            </div>

            <div>
              <p>Total Price</p>
              <h4>
                {FormatCurrency(budgetSummaryDataById?.responseObject?.total) ||
                  "N/A"}
              </h4>{" "}
              {/* Updated with total price */}
            </div>
          </div>

          <div>
            <div>
              <p>Actual Expenditure</p>
              <h4>
                {FormatCurrency(
                  budgetSummaryDataById?.responseObject?.actualExpenditure
                ) || "N/A"}
              </h4>{" "}
              {/* Updated with actual expenditure */}
            </div>
            <div>
              <p>Date Created</p>
              <h4>
                {FormatDateTime(
                  budgetSummaryDataById?.responseObject?.createdDate,
                  "ll"
                ) || "N/A"}
              </h4>{" "}
              {/* Updated with date created */}
            </div>
            <div>
              <p>Last Updated</p>
              <h4>
                {FormatDateTime(
                  budgetSummaryDataById?.responseObject?.updateDate,
                  "ll"
                ) || "N/A"}
              </h4>{" "}
              {/* Updated with last updated date */}
            </div>
          </div>
        </div>
      </section>
      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>Recommendation</h4>
        <div className={DashboardStyle.labels_group}>
          <div>
            <div>
              <p>Recommended Item Name</p>
              <h4>{requisition?.recommendedAsset || "-"}</h4>
            </div>
            <div>
              <p>Recommend Specifications</p>
              <h4>{requisition?.recommendedAssetDescription || "-"}</h4>
            </div>
          </div>
        </div>
      </section>

      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          Approval
          <br /> Designation
        </h4>
        <div
          className={`${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads}`}
        >
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th>Initiator Name</th>
                <th>Approval Designation Desc</th>
                <th>Date Uploaded</th>
                <th>Status</th>
                <th>Approval Designation Comment</th>
              </tr>
            </thead>
            <tbody>
              {requisition?.approvalDesignation?.map((x, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{x?.initiatorName}</td>
                  <td>{x?.approvalDesignationDesc}</td>
                  <td>{FormatDateTime(x?.createdAt)}</td>
                  <td>
                    {/* <TableActionsDownload url={x?.fileURL} /> */}
                    {x?.approvalCurrentDesignation}
                  </td>
                  <td>{x?.comment}</td>
                </tr>
              ))}
            </tbody>
          </Table>

          <PreviewBtn
            allData={requisition?.approvalResponse}
            data={requisition?.approvalResponse?.history || []}
          />
        </div>
      </section>

      <section className={DashboardStyle.form_section}>
        <h4 className={DashboardStyle.form_section_title}>
          Documents <br /> Uploads
        </h4>
        <div
          className={`${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads}`}
        >
          <Table>
            <thead>
              <tr>
                <th>#</th>
                <th>File Name</th>
                <th>File Type</th>
                {/* <th>Date Uploaded</th> */}
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {documents?.map((x, index) => (
                <tr>
                  <td>{index + 1}</td>
                  <td>{x?.fileName}</td>
                  <td>{x?.folder}</td>
                  {/* <td>{FormatDateTime(x?.dateUploaded)}</td> */}
                  <td>
                    <TableActionsDownload
                      url={x?.file}
                      base64File={x?.file}
                      fileType={x?.fileType?.split(",")[0]}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </div>
      </section>
      {requisition?.deliveryNote && (
        <section className={DashboardStyle.form_section}>
          <h4 className={DashboardStyle.form_section_title}>
            Delivery <br /> Note
          </h4>
          <div
            className={` ${DashboardStyle.labels_group} ${DashboardStyle.labels_group_downloads} `}
          >
            <Table>
              <thead>
                <tr>
                  <th>#</th>
                  <th>File Name</th>
                  <th>File Type</th>
                  {/* <th>Date Uploaded</th> */}
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {documents?.map((dat, index) => (
                  <tr key={index}>
                    <td>{index}</td>
                    <td>{dat.fileName}</td>
                    <td>{dat?.fileType}</td>
                    {/* <td>
                    {FormatDateTime(requisition?.deliveryNote?.dateUploaded)}
                  </td> */}
                    <td>
                      <TableActionsDownload
                        url={dat?.file}
                        fileType={dat?.fileType?.split(",")[0]}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </Table>
          </div>
        </section>
      )}
      <AddPaymentTerms
        id={id}
        requisition={requisition}
        data={data}
        setRefresh={setRefresh}
        refersh={refersh}
        paymentTerms={paymentTerms}
      />
    </PageLayout>
  );
}

export { ViewEmployeeQuotation };
